<template>
  <main class="container-fluid py-3">
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <div class="container-fluid">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb bg-transparent mb-0 pt-1 px-0">
            <li class="breadcrumb-item"><a class="text-secondary">Recepciones</a></li>
            <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
          </ol>
          <h5 class="mb-0">Dashboard</h5>
        </nav>
        <!-- <div class="collapse navbar-collapse" id="navbar">
          <div class="ml-auto pr-3 d-flex align-items-center">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-search" aria-hidden="true"></i></span>
              </div>
              <input type="text" class="form-control" placeholder="Type here...">
            </div>
          </div>
        </div> -->
      </div>
    </nav>
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-xl-3 col-sm-6 mb-4">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-8">
                  <div class="numbers">
                    <p class="text-muted mb-0">Today's Money</p>
                    <h5 class="mb-0">
                      $53,000
                      <span class="text-success small">+55%</span>
                    </h5>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="bg-primary text-white p-3 rounded d-inline-block">
                    <i class="fas fa-dollar-sign fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-4">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-8">
                  <div class="numbers">
                    <p class="text-muted mb-0">Today's Users</p>
                    <h5 class="mb-0">
                      2,300
                      <span class="text-success small">+3%</span>
                    </h5>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="bg-primary text-white p-3 rounded d-inline-block">
                    <i class="fas fa-users fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-4">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-8">
                  <div class="numbers">
                    <p class="text-muted mb-0">New Clients</p>
                    <h5 class="mb-0">
                      +3,462
                      <span class="text-danger small">-2%</span>
                    </h5>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="bg-primary text-white p-3 rounded d-inline-block">
                    <i class="fas fa-handshake fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6">
          <div class="card">
            <div class="card-body p-3">
              <div class="row">
                <div class="col-8">
                  <div class="numbers">
                    <p class="text-muted mb-0">Sales</p>
                    <h5 class="mb-0">
                      $103,430
                      <span class="text-success small">+5%</span>
                    </h5>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="bg-primary text-white p-3 rounded d-inline-block">
                    <i class="fas fa-shopping-cart fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-lg-8 col-md-6 mb-md-0 mb-4">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-lg-6 col-7">
                  <h6 class="text-success">Recepciones pendientes de asignar lotes</h6>
                  <!-- <p class="text-muted mb-0">
                    <i class="fa fa-check text-info" aria-hidden="true"></i>
                    <span class="ml-1">30 </span> pendientes de asignar este mes
                  </p> -->
                </div>
                <!-- <div class="col-lg-6 col-5 my-auto text-right">
                  <div class="dropdown float-right pr-4">
                    <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-ellipsis-v text-secondary"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item" href="#">Action</a>
                      <a class="dropdown-item" href="#">Another action</a>
                      <a class="dropdown-item" href="#">Something else here</a>
                    </div>
                    <p>{{facturasSinIngreso}}</p>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="card-body p-0">
              <!-- <div class="p-3">
                <label for="productoIdInput" class="form-label">ID Producto:</label>
                <input
                  type="text"
                  class="form-control"
                  id="productoIdInput"
                  v-model="productoId"
                  @keyup.enter="facturasSinIngreso"
                  placeholder="Introduce el ID del producto (opcional)"
                />
                <button @click="obtenerFacturasSinIngreso" class="btn btn-primary mt-2">
                  Buscar Facturas
                </button>
              </div> -->
              <div class="table-responsive">
                <!-- <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary small">Producto</th>
                      <th class="text-uppercase text-secondary small pl-2">Recepción</th>
                      <th class="text-center text-uppercase text-secondary small"> Factura </th>
                      <th class="text-center text-uppercase text-secondary small"> Fecha Creación </th>
                      <th class="text-center text-uppercase text-secondary small"> Cantidad </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="facturasSinIngreso.length === 0">
                      <td colspan="5" class="text-center">No hay facturas sin lote disponibles.</td>
                    </tr>
                    <tr v-for="factura in facturasSinIngreso" :key="factura.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0">{{factura.producto_id }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="small  mb-0">{{ factura.recepcion }}</p>
                      </td>
                      <td class="text-center small">
                        <span class="text-secondary ">{{
                          factura.factura
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span class="text-secondary small ">{{
                          factura.fecha_documento
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span class="text-secondary small ">{{
                          factura.cantidad
                        }}</span>
                      </td>
                      <td>
                         <button class="btn btn-sm btn-success"> Lotes</button>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <div>
                <!-- Filtros -->
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label>Fecha desde:</label>
                    <input 
                      type="date" 
                      class="form-control" 
                      v-model="fechaDesde"
                      @change="aplicarFiltros"
                    >
                  </div>
                  <div class="col-md-4">
                    <label>Producto ID:</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="productoId"
                      placeholder="ID del producto"
                      @input="aplicarFiltros"
                    >
                  </div>
                  <div class="col-md-4">
                    <label>Número de Recepción:</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model="recepcionNumero"
                      placeholder="Número de recepción"
                      @input="aplicarFiltros"
                    >
                  </div>
                </div>

                <!-- Botones de acción -->
                <div class="row mb-3">
                  <div class="col-md-12">
                    <button class="btn btn-primary mr-2" @click="aplicarFiltros" :disabled="loading">
                      <i class="fas fa-search"></i> Buscar
                    </button>
                    <button class="btn btn-secondary mr-2" @click="limpiarFiltros" :disabled="loading">
                      <i class="fas fa-times"></i> Limpiar
                    </button>
                    
                    <!-- Selector de tamaño de página -->
                    <select class="form-control d-inline-block" style="width: auto; margin-left: 10px;" 
                            v-model="pageSize" @change="cambiarTamanoPagina(pageSize)">
                      <option value="10">10 por página</option>
                      <option value="25">25 por página</option>
                      <option value="50">50 por página</option>
                      <option value="100">100 por página</option>
                    </select>
                  </div>
                </div>
                <!-- Información de resultados -->
                <div class="row mb-2" v-if="paginationData.count > 0">
                  <div class="col-md-12">
                    <small class="text-muted">
                      Mostrando {{ ((currentPage - 1) * pageSize) + 1 }} - 
                      {{ Math.min(currentPage * pageSize, paginationData.count) }} 
                      de {{ paginationData.count }} registros
                    </small>
                  </div>
                </div>

                <!-- Loading -->
                <div v-if="loading" class="text-center py-4">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
                </div>

                <!-- Tabla de resultados -->
                <div v-else-if="facturasSinIngreso.length > 0">
                  <!-- <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button
                        class="nav-item nav-link active p-0"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >Información General</button
                      >
                      <button
                        class="nav-item nav-link"
                        id="direccion-tab"
                        data-toggle="tab"
                        href="#direccion"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="true"
                        >Dirección</button
                      >
                    </div>
                  </nav> -->
                  <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary small">Producto</th>
                      <th class="text-center text-uppercase text-secondary small">Recepción</th>
                      <th class="text-center text-uppercase text-secondary small"> Factura </th>
                      <th class="text-center text-uppercase text-secondary small"> Fecha Creación </th>
                      <th class="text-center text-uppercase text-secondary small"> Cantidad </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="facturasSinIngreso.length === 0">
                      <td colspan="5" class="text-center">No hay facturas sin lote disponibles.</td>
                    </tr>
                    <tr v-for="factura in facturasSinIngreso" :key="factura.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0">{{factura.producto_id }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-center small">
                        <span class="text-secondary text-center">{{ factura.recepcion }}</span>
                      </td>
                      <td class="text-center small">
                        <span class="text-secondary ">{{ factura.factura }}</span>
                      </td>
                      <td class="text-center">
                        <span class="text-secondary small ">{{
                          factura.fecha_documento
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span class="text-secondary small ">{{
                          factura.cantidad
                        }}</span>
                      </td>
                      <td>
                         <button class="btn btn-sm btn-success"> Lotes</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                  <!-- <table class="table table-striped table-hover">
                    <thead class="thead-dark">
                      <tr>
                        <th>Producto ID</th>
                        <th>Recepción</th>
                        <th>Factura</th>
                        <th>Fecha Creación</th>
                        <th>Cantidad</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="factura in facturasSinIngreso" :key="factura.factura_d_id">
                        <td>{{ factura.producto_id }}</td>
                        <td>{{ factura.recepcion }}</td>
                        <td>{{ factura.factura }}</td>
                        <td>{{ new Date(factura.fecha_creacion).toLocaleDateString() }}</td>
                        <td>{{ factura.cantidad }}</td>
                        <td>
                        </td>
                      </tr>
                    </tbody>
                  </table> -->

                  <!-- Componente de paginación -->
                  <Pagination 
                    :data="paginationData"
                    :current-page="currentPage"
                    @pagechanged="onPageChanged"
                    tipo="COMPLETO"
                  />
                </div>

                <!-- Sin resultados -->
                <div v-else class="text-center py-4">
                  <p class="text-muted">No se encontraron facturas sin ingreso registrado.</p>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="card h-100">
            <div class="card-header pb-0">
              <h6>Orders overview</h6>
              <p class="text-muted">
                <i class="fa fa-arrow-up text-success" aria-hidden="true"></i>
                <span class="">24%</span> this month
              </p>
            </div>
            <div class="card-body p-3">
              <div class="list-group list-group-flush">
                <div class="list-group-item d-flex align-items-center mb-3">
                  <span class="rounded-circle bg-success text-white p-2 mr-3">
                    <i class="fas fa-bell"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small"> $2400, Design changes</h6>
                    <p class="text-muted small mb-0">22 DEC 7:20 PM</p>
                  </div>
                </div>
                <div class="list-group-item d-flex align-items-center mb-3">
                  <span class="rounded-circle bg-danger text-white p-2 mr-3">
                    <i class="fab fa-html5"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small">New order #1832412</h6>
                    <p class="text-muted small mb-0">21 DEC 11 PM</p>
                  </div>
                </div>
                <div class="list-group-item d-flex align-items-center mb-3">
                  <span class="rounded-circle bg-info text-white p-2 mr-3">
                    <i class="fas fa-shopping-cart"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small">Server payments for April</h6>
                    <p class="text-muted small mb-0">21 DEC 9:34 PM</p>
                  </div>
                </div>
                <div class="list-group-item d-flex align-items-center mb-3">
                  <span class="rounded-circle bg-warning text-white p-2 mr-3">
                    <i class="fas fa-credit-card"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small">New card added for order #4395133</h6>
                    <p class="text-muted small mb-0">20 DEC 2 PM</p>
                  </div>
                </div>
                <div class="list-group-item d-flex align-items-center mb-3">
                  <span class="rounded-circle bg-primary text-white p-2 mr-3">
                    <i class="fas fa-key"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small">Unlock packages for development</h6>
                    <p class="text-muted small mb-0">18 DEC 4 PM</p>
                  </div>
                </div>
                <div class="list-group-item d-flex align-items-center">
                  <span class="rounded-circle bg-dark text-white p-2 mr-3">
                    <i class="fas fa-dollar-sign"></i>
                  </span>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 small">New order #9583120</h6>
                    <p class="text-muted small mb-0">17 DEC</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
  <script>
  import DynamicService from "@/services/commons/DynamicService";

  export default {

    data() {
      return {
        facturasSinIngreso: [],
         paginationData: {
        count: 0,
        next: null,
        previous: null,
        results: []
      },
        loading: false,
        currentPage: 1,
        pageSize: 10,
        // Filtros para la consulta
        fechaDesde: '2024-12-01',
        productoId: null,
        recepcionNumero: null
      }
    },
    mounted() {
      // Cargar datos al montar el componente
      this.obtenerFacturasSinIngreso(1)
    },
    methods: {
      // Método alternativo si usaste una action en viewset existente
      obtenerFacturasSinIngreso(page = 1) {
        
        try {
          this.loading = true
          this.currentPage = page

          let params = {
            page: 3,
            page_size: this.pageSize
          }
          
          if (this.fechaDesde) {
            params.fecha_desde = this.fechaDesde
          }
          if (this.productoId) {
            params.producto_id = this.productoId
          }
          if (this.recepcionNumero) {
            params.recepcion_numero = this.recepcionNumero
          }
          console.log("Sí se ejecuta la funcion de traer facturas sin igreso y llega antes de dynamic de params", params)
          // Si usaste action en el viewset de facturas existente
          DynamicService.getActionList("wms","detalle_autorizar","facturas_ingreso_sin_lotes", params
          ).then((response) => {
            console.log(response.data)
            this.facturasSinIngreso = response.data.results
            this.paginationData = {
              count: response.data.length,
              next: null,
              previous: null,
              results: response.data
            }
            console.log("facturas sin ingreso", this.facturasSinIngreso)
          }).catch((error) => {
            this.paginationData = { count: 0, results: [] }
            console.error('Error al obtener las facturas sin ingreso: ', error)
          }).finally(() => {
            this.loading = false
          })
          
        } catch (error) {
          console.error('Error al obtener las facturas sin ingreso: ', error)
          this.loading = false
        }
      },
      // Método llamado cuando se cambia de página
      onPageChanged(page) {
        this.obtenerFacturasSinIngreso(page)
      },

      // Método para aplicar filtros (siempre vuelve a página 1)
      aplicarFiltros() {
        this.currentPage = 1
        this.obtenerFacturasSinIngreso(1)
      },

      // Método para limpiar filtros
      limpiarFiltros() {
        this.fechaDesde = '2024-12-01'
        this.productoId = null
        this.recepcionNumero = null
        this.currentPage = 1
        this.obtenerFacturasSinIngreso(1)
      },

      // Método para cambiar el tamaño de página
      cambiarTamanoPagina(nuevoTamano) {
        this.pageSize = nuevoTamano
        this.currentPage = 1
        this.obtenerFacturasSinIngreso(1)
    },
  },
};
  </script>
    
    <style scoped>
    /* Any component-specific styles can go here if needed */
    </style>